/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedDetailPayments_viewer$ref = any;
type PdpSharedDetailShipping_viewer$ref = any;
export type PdpRespShippingReturns_viewer$ref = any;
export type PdpRespShippingReturns_viewer = {
    readonly isItemInvoiceEnabled: boolean | null;
    readonly " $fragmentRefs": PdpSharedDetailShipping_viewer$ref & PdpSharedDetailPayments_viewer$ref;
    readonly " $refType": PdpRespShippingReturns_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespShippingReturns_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isItemInvoiceEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "INVOICE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"INVOICE\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedDetailShipping_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedDetailPayments_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'c6a7befc721458cc3fc62946bd7f9782';
export default node;
